var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalcollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 6,
    fill: "#FFE6B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 34.75C22.25 35.6875 21.9875 36.575 21.525 37.325C20.6625 38.775 19.075 39.75 17.25 39.75C15.425 39.75 13.8375 38.775 12.975 37.325C12.5125 36.575 12.25 35.6875 12.25 34.75C12.25 31.9875 14.4875 29.75 17.25 29.75C20.0125 29.75 22.25 31.9875 22.25 34.75Z",
    stroke: "#F4A511",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3018 34.7494L16.5393 35.9869L19.2018 33.5244",
    stroke: "#F4A511",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1893 19.8125C32.8893 19.7625 32.5768 19.75 32.2518 19.75H19.7518C19.4018 19.75 19.0643 19.775 18.7393 19.825C18.9143 19.475 19.1643 19.15 19.4643 18.85L23.5268 14.775C25.2393 13.075 28.0143 13.075 29.7268 14.775L31.9143 16.9874C32.7143 17.7749 33.1393 18.775 33.1893 19.8125Z",
    stroke: "#F4A511",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 26V32.25C38.5 36 36 38.5 32.25 38.5H20.5375C20.925 38.175 21.2625 37.775 21.525 37.325C21.9875 36.575 22.25 35.6875 22.25 34.75C22.25 31.9875 20.0125 29.75 17.25 29.75C15.75 29.75 14.4125 30.4125 13.5 31.45V26C13.5 22.6 15.55 20.225 18.7375 19.825C19.0625 19.775 19.4 19.75 19.75 19.75H32.25C32.575 19.75 32.8875 19.7625 33.1875 19.8125C36.4125 20.1875 38.5 22.575 38.5 26Z",
    stroke: "#F4A511",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 26.625H34.75C33.375 26.625 32.25 27.75 32.25 29.125C32.25 30.5 33.375 31.625 34.75 31.625H38.5",
    stroke: "#F4A511",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalcollection);
export default __webpack_public_path__ + "static/media/totalcollection.917efe6c09a5ae95f96381335b07fb78.svg";
export { ForwardRef as ReactComponent };